import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 30px;
  height: calc(100% - 30px);
`;

export {
  Container,
};
